// src/components/shared/Navbar.js
import { useState, useEffect } from "react";
import { useLang } from "../../context/LanguageContext";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "../../styles/navbar.css";

export default function Navbar() {
  const { lang, t, toggleLang } = useLang();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [scrolled,  setScrolled]  = useState(false);
  const [menuOpen,  setMenuOpen]  = useState(false);
  const [isMobile,  setIsMobile]  = useState(window.innerWidth < 992);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    const onResize = () => {
      setIsMobile(window.innerWidth < 992);
      if (window.innerWidth >= 992) setMenuOpen(false);
    };
    window.addEventListener("scroll", onScroll);
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  const scroll = (id) => {
    setMenuOpen(false);
    setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 10);
  };

  const links = [
    ["skills", "skills"], ["experience", "experience"],
    ["projects", "projects"], ["certificates", "certificates"], ["contact", "contact"],
  ];

  return (
    <nav className="navbar">
      <div className={`navbar__inner${scrolled ? " navbar__inner--scrolled" : ""}`}>
        <a href="/" className="navbar__logo">
          D<span className="navbar__logo-accent">.</span>İNEL
        </a>

        {/* Desktop */}
        {!isMobile && (
          <ul className="navbar__links">
            {links.map(([id, key]) => (
              <li key={id}>
                <button className="navbar__link" onClick={() => scroll(id)}>
                  {t.nav[key]}
                </button>
              </li>
            ))}
            <li>
              <button className="navbar__lang-btn" onClick={toggleLang}>
                {lang === "tr" ? "EN" : "TR"}
              </button>
            </li>
            {user && (
              <li>
                <button className="navbar__admin-btn" onClick={() => navigate("/myprvtpage")}>
                  Panel
                </button>
              </li>
            )}
          </ul>
        )}

        {/* Mobile: lang + hamburger */}
        {isMobile && (
          <div className="navbar__mobile-right">
            <button className="navbar__lang-btn" onClick={toggleLang}>
              {lang === "tr" ? "EN" : "TR"}
            </button>
            <button
              className={`hamburger${menuOpen ? " hamburger--open" : ""}`}
              onClick={() => setMenuOpen(o => !o)}
              aria-label="Menü"
            >
              <span className="hamburger__bar" />
              <span className="hamburger__bar" />
              <span className="hamburger__bar" />
            </button>
          </div>
        )}
      </div>

      {/* Mobile dropdown */}
      {isMobile && (
        <div className={`navbar__mobile-menu${menuOpen ? " navbar__mobile-menu--open" : " navbar__mobile-menu--closed"}`}>
          <div className="navbar__mobile-links">
            {links.map(([id, key]) => (
              <button key={id} className="navbar__mobile-link" onClick={() => scroll(id)}>
                {t.nav[key]}
              </button>
            ))}
            {user && (
              <button
                className="navbar__mobile-link navbar__mobile-link--admin"
                onClick={() => { setMenuOpen(false); navigate("/myprvtpage"); }}
              >
                Panel →
              </button>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}
